import React, { useEffect, useState } from 'react';
import SolicitationService from '../../../../services/SolicitationService/SolicitationService'
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store';
import { UserState } from '../../../../store/reducers/userReducer';
import { MenuState } from '../../../../store/reducers/menuReducer';
import LcAccordion from '../../../../components/Generic/LcAccordion';
import moment from 'moment';
import LcLoading from '../../../../components/Generic/LcLoading';
import { SolicitationView } from '../../../../models/SolicitationView';
import HeyHoUserService from '../../../../services/HeyHoUserService/HeyHoUserService';
import { PPTextField, PPTooltip } from 'processor-plataform-ui';
import ContractService from '../../../../services/ContractService/ContractService';

interface Props {
    solicitation: SolicitationView,
}

const SolicitationFinancial: React.FC<Props> = (props) => {
    // const heyHoUserService = new HeyHoUserService(props);
    const solicitationService = new SolicitationService(props);
    const contractService = new ContractService(props);

    // const user = useSelector<RootState, UserState>(state => state.user);
    // const menu = useSelector<RootState, MenuState>(state => state.menu);

    // const [requester, setRequester] = useState<any[any]>([])
    // const [sendMail, setSendMail] = useState<string>('')
    const [loading, setLoading] = useState<boolean>(false);

    // const [contractList, setContractList] = useState<any[]>([]);
    // const [billingTypesList, setBillingTypesList] = useState<any[]>([
    //     { label: "", value: 0 },
    //     { label: "Faturar", value: 1 },
    //     { label: "Não Faturar", value: 2 }
    // ]);

    const selectedValuesAux = {
        idContract: 0,
        idBillingTypes: 0,
        hourValue: "R$ 0,00",
        idRaa: 0,
        revenueDate: "",
        contractDescription: ""
    }

    const [selectedValues, setSelectedValues] = useState<any>({ ...selectedValuesAux });

    useEffect(() => {
        if (props.solicitation) {
            getFinancial();
        }
    }, [props.solicitation]);

    const getFinancial = async () => {
        setLoading(true);

        try {
            const response = await solicitationService.getViewSolicitationFinancial(props.solicitation.id);

            setSelectedValues({
                ...selectedValues,
                idContract: response.data[0].idContract,
                idBillingTypes: (response.data[0].idRevenueType) ? Number(response.data[0].idRevenueType) : '0',
                idRaa: (response.data[0].idRaa) ? Number(response.data[0].idRaa) : 0,
                hourValue: (response.data[0].hourValue) ? `R$ ${response.data[0].hourValue},00` : "R$ 0,00",
                revenueDate: (response.data[0].revenueDate) ? moment(response.data[0].revenueDate).format("YYYY-MM-DD") : "",
                contractDescription: response.data[0].contractDescription,
            });

            // await getContractsList(props.solicitation.idCustomer);
            // console.info(response.data);
        }
        catch (error) {
            console.warn(error);
        }

        setLoading(false);
    }

    const getContractsList = async (idCustomer: number) => {
        try {
            const contractResponse = await contractService.getCurrentContractsByIdCustomer(idCustomer);
            // setContractList(mountDropList(contractResponse.data));
        }
        catch (error) {
            console.warn(error);
        }
    }

    const mountDropList = (list: any[]) => {
        let result = (list.length == 1) ? [] : [{ label: "", value: 0 }];

        if (list.length > 0) {
            let _list = list.filter(c => (c.disabled) ? c.disabled === 0 || c.disabled === false : c)
                .map(c => { return { label: c.description, value: c.id } })
                .sort((a, b) => { return a.label > b.label ? 1 : -1 })

            return [...result, ..._list];
        }
        else {
            return result;
        }
    }

    const handleChange = (event: any) => {
        const { name, value } = event.target;

        setSelectedValues({
            ...selectedValues,
            [name]: (name === "revenueDate") ? value : Number(value)
        });
    }

    return (
    <LcAccordion title="Informações Financeiras" visible={false} iconNormal>
        <LcLoading loading={loading}>
            <div style={{ marginTop: "15px" }}>
                <PPTextField
                    label={"Contrato"}
                    onChange={handleChange}
                    name={"idContract"}
                    style={{ width: "23rem" }}
                    value={selectedValues.idContract}
                    readOnly
                />
            </div>

            <div style={{ marginTop: "15px" }}>
                <PPTooltip content={selectedValues.contractDescription} trigger={"hover"} position={"center"}>
                    <PPTextField
                        label={"Descricão contrato"}
                        onChange={handleChange}
                        name={"contractDescription"}
                        style={{ width: "23rem" }}
                        value={selectedValues.contractDescription}
                        readOnly
                    />
                </PPTooltip>

            </div>

            <div style={{ marginTop: "15px" }}>
                <PPTextField
                    label={"Tipos de faturamento"}
                    onChange={handleChange}
                    name={"idBillingTypes"}
                    style={{ width: "23rem" }}
                    value={selectedValues.idBillingTypes}
                    readOnly
                />
            </div>

            <div style={{ marginTop: "15px" }}>
                <PPTextField
                    label={"Valor da hora"}
                    onChange={handleChange}
                    value={selectedValues.hourValue}
                    style={{ width: "23rem" }}
                    name={"hourValue"}
                    autoComplete={"off"}
                    readOnly
                />
            </div>

            <div style={{ marginTop: "15px" }}>
                <PPTextField
                    label={"RAT agrupada"}
                    onChange={handleChange}
                    value={selectedValues.idRaa}
                    style={{ width: "23rem" }}
                    name={"idRaa"}
                    autoComplete={"off"}
                    readOnly
                />
            </div>

            <div style={{ marginTop: "15px" }}>
                <PPTextField
                    label={"Faturado em"}
                    type={"date"}
                    style={{ width: "23rem" }}
                    onChange={handleChange}
                    value={selectedValues.revenueDate}
                    name={"revenueDate"}
                    readOnly
                />
            </div>
        </LcLoading>
    </LcAccordion>
    );
};

export default SolicitationFinancial;